export default __webpack_public_path__ + "static/media/calendar-prev.41b7e457.svg";